import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Button, Input, Label, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import WidgetsSectionTitle from '../../../WidgetsSectionTitle/WidgetSectionTitle';
import { getnumbers } from '../../../Redux/Actions/Twilio';
import { createWebhookConfig, updateWebhookConfig, fetchWebhookConfig ,deleteWebhookConfig } from '../../../Redux/Actions/AI/aiwebhook';
import Multiselect from 'multiselect-react-dropdown';
import { toast } from 'react-toastify';
import { X } from 'react-feather';

const WebhookConfig = ({
  getnumbers,
  numbers,
  createWebhookConfig,
  updateWebhookConfig,
  fetchWebhookConfig,
  deleteWebhookConfig 
}) => {
  const [webhookUrl, setWebhookUrl] = useState('');
  const [selectedNumbers, setSelectedNumbers] = useState([]);
  const [keyValuePairs, setKeyValuePairs] = useState([{ key: '', value: '' }]);
  const [webhookId, setWebhookId] = useState(null);
  const [initialWebhookUrl, setInitialWebhookUrl] = useState('');
const [initialKeyValuePairs, setInitialKeyValuePairs] = useState([{ key: '', value: '' }]);
const [initialNumbers, setInitialNumbers] = useState([]);


useEffect(() => {

console.log("webhookId updated: ",webhookId)
}, [webhookId]);


useEffect(() => {
  getnumbers();
  fetchWebhookConfig().then((res) => {
    if (res) {
      setWebhookUrl(res.webhookUrl || '');
      setInitialWebhookUrl(res.webhookUrl || '');

      setSelectedNumbers(res.numbers || []);
      setInitialNumbers(res.numbers || []);

      const mappedKeys = [];
      if (res.keys) {
        for (let [k, v] of Object.entries(res.keys)) {
          mappedKeys.push({ key: k, value: v });
        }
      }

      const keysToSet = mappedKeys.length ? mappedKeys : [{ key: '', value: '' }];
      setKeyValuePairs(keysToSet);
      setInitialKeyValuePairs(keysToSet);

      setWebhookId(res._id);
    }
  });
}, []);


const isKeyValuePairsEqual = (a, b) => {
  if (a.length !== b.length) return false;
  return a.every((pair, index) =>
    pair.key.trim() === b[index].key.trim() && pair.value.trim() === b[index].value.trim()
  );
};


const areAllRowsFilled = keyValuePairs.every(
  (pair) => pair.key.trim() !== '' && pair.value.trim() !== ''
);

const isWebhookUrlChanged = webhookUrl.trim() !== initialWebhookUrl.trim();

const isKeyValueContentChanged = !isKeyValuePairsEqual(keyValuePairs, initialKeyValuePairs);

const isConfigChanged =
  webhookUrl.trim() !== '' &&
  areAllRowsFilled &&
  (isWebhookUrlChanged || isKeyValueContentChanged);


const isNumbersChanged = JSON.stringify(selectedNumbers) !== JSON.stringify(initialNumbers);



  const handleNumberSelect = (list) => {
    const formatted = list.map((item) => ({
      numberID: item._id,
      number: item.number,
      numberName: item.name || item.number
    }));
    setSelectedNumbers(formatted);
  };

  const handleNumberRemove = (list) => {
    const formatted = list.map((item) => ({
      numberID: item._id,
      number: item.number,
      numberName: item.name || item.number
    }));
    setSelectedNumbers(formatted);
  };

  const handlePairChange = (index, field, value) => {
    const updated = [...keyValuePairs];
    updated[index][field] = value;
    setKeyValuePairs(updated);
  };

  const addKeyValuePair = () => {
    setKeyValuePairs([...keyValuePairs, { key: '', value: '' }]);
  };

  const removeKeyValuePair = (index) => {
    if (keyValuePairs.length > 1) {
      const updated = keyValuePairs.filter((_, i) => i !== index);
      setKeyValuePairs(updated);
    }
  };

const handleSave = async () => {
  const keysObject = {};
  keyValuePairs.forEach((pair) => {
    if (pair.key && pair.value) {
      keysObject[pair.key.replace(/\s+/g, '_')] = pair.value;
    }
  });

  const dataToSend = {
    forWebhook:true,
    webhookUrl,
    fieldsToExtract: keysObject
  };

  if (webhookId) {
    console.log("entered save config update part")

    await updateWebhookConfig(webhookId, dataToSend);
  } else {
        console.log("entered save config create part")

  const result = await createWebhookConfig(dataToSend);
    if (result?._id) {
      setWebhookId(result._id); // ✅ Set webhookId after creation
    }
    }

  toast.success('Webhook configuration saved!');
  setInitialWebhookUrl(webhookUrl);
setInitialKeyValuePairs(keyValuePairs.map(p => ({ ...p })));
};

const isResetEnabled = webhookId !== null;


const handleReset = async () => {
  const res = await deleteWebhookConfig();
  if (res?.success) {
    setWebhookUrl('');
    setKeyValuePairs([{ key: '', value: '' }]);
    setWebhookId(null);
    setSelectedNumbers([]);  // ✅ Clear selected numbers
    setInitialNumbers([]);   // ✅ Clear initial numbers
    setInitialWebhookUrl('');
    setInitialKeyValuePairs([{ key: '', value: '' }]);

    toast.success('Successfully reset webhook settings and selected numbers.');
  } else {
    toast.error('Failed to reset configurations');
  }
};


const handleNumberSave = async () => {
    console.log("entered handle save numbers")

  const dataToSend = {
    forNumber:true,
    numbers: selectedNumbers
  };




 if (webhookId) {
 
 await updateWebhookConfig(webhookId, dataToSend);
    toast.success('Numbers updated!');
    setInitialNumbers([...selectedNumbers]);

  } else {
        console.log("entered save config create part")

  const result = await createWebhookConfig(dataToSend);
    if (result?._id) {
      setWebhookId(result._id); // ✅ Set webhookId after creation
      toast.success('Numbers updated!');
    setInitialNumbers([...selectedNumbers]);
    }
    }












};


  const numberOptions = numbers.map((item) => ({
    _id: item._id,
    number: item.number,
    name: item.name
  }));

  return (
    <>
    <Row>
          <Col xs="12">
                <WidgetsSectionTitle
                  className="my-2"
                  title="Webhook Configuration"
                  subtitle="Set up your webhook configuration to get data of caller on webhook"
                  icon="user"
                />
              </Col>
      <Col xs="12">
        <Card>
          <CardBody>
            <FormGroup>
              <Label>Webhook URL</Label>
              <Input
                type="text"
                placeholder="https://example.com/webhook"
                value={webhookUrl}
                onChange={(e) => setWebhookUrl(e.target.value)}
              />
            </FormGroup>

            <Label>Data to Fetch</Label>
            {keyValuePairs.map((pair, index) => (
              <FormGroup key={index} row>

                <Col md={4} className="position-relative">
                  <Input
                    type="text"
                    placeholder="Enter key"
                    value={pair.key}
                    onChange={(e) => handlePairChange(index, 'key', e.target.value)}
                  />
                </Col>

                <Col md={7} className="position-relative">
                  <Input
                    type="textarea"
                    placeholder="Enter description of the key"
                    value={pair.value}
                    onChange={(e) => handlePairChange(index, 'value', e.target.value)}
                  />
                </Col>
                <Col md={1} className="d-flex align-items-start">
                  {keyValuePairs.length > 1 && (
                    <Button color="link" onClick={() => removeKeyValuePair(index)}><X size={16} color="black" /></Button>
                  )}
                </Col>
              </FormGroup>
            ))}

            <Button color="success" style={{fontSize:"12px"}} onClick={addKeyValuePair} className="mb-3">
              Add
            </Button>

            <div className="mb-4">
           <Button
  style={{ fontSize: '12px', backgroundColor: '#16A34A', borderColor: '#16A34A' }}
  onClick={handleSave}
  disabled={!isConfigChanged}
>
  Save Configuration
</Button>

            </div>

  </CardBody>
        </Card>
      </Col>

  <Col xs="12">
                <WidgetsSectionTitle
                  className="my-2"
                  title="Select Numbers"
                  subtitle="Select numbers for AI Live Calling feature"
                  icon="user"
                />
              </Col>



 <Col xs="12">
        <Card>
          <CardBody>

            <FormGroup>
              <Label>Select Numbers</Label>
              <Multiselect
                options={numberOptions}
                displayValue="name"
                onSelect={handleNumberSelect}
                onRemove={handleNumberRemove}
                selectedValues={selectedNumbers.map((num) => ({
                  _id: num.numberID,
                  number: num.number,
                  name: num.numberName
                }))}
                placeholder="Select numbers"
                showCheckbox
                menuPortalTarget={document.body}
              />
            </FormGroup>
 <div className="d-flex gap-2 mt-3 mb-4">
  <Button
            style={{ fontSize: '12px', backgroundColor: '#16A34A', borderColor: '#16A34A', marginRight: 8 }}
    
    onClick={handleNumberSave}
    disabled={!isNumbersChanged}
  >
    Save
  </Button>

  <Button
    color="danger"
    style={{fontSize:"12px"}}
    onClick={handleReset}
    disabled={!initialWebhookUrl || initialWebhookUrl.trim() === ''}
  >
    Reset Configurations
  </Button>
</div>
          </CardBody>
        </Card>
      </Col>
    </Row>
    </>
  );
};

const mapStateToProps = (state) => ({
  numbers: state.Twilio.numbers || [],
   webhookId: state.webhook?.config?._id || null  // ✅ get webhookId from Redux
});

export default connect(mapStateToProps, {
  getnumbers,
  createWebhookConfig,
  updateWebhookConfig,
  fetchWebhookConfig,
  deleteWebhookConfig 
})(WebhookConfig);
